import React from 'react'
import Layout from '../Layout'
import '../CustomAssets/Css/Pages/Careers.css';
import { CiCircleAlert } from "react-icons/ci";
import { NavLink } from 'react-router-dom';

export default function Careers() {
    const jobCards = [
        {
            title: "Software Engineer",
            description: "Develop and maintain software applications for clients.",
            listItems: [
                "Write clean, scalable code using programming languages.",
                "Collaborate with cross-functional teams to define project requirements.",
                "Test and debug applications to ensure functionality."
            ]
        },
        {
            title: "Data Analyst",
            description: "Analyze and interpret complex datasets to help decision-making.",
            listItems: [
                "Collect and clean data from multiple sources.",
                "Use statistical tools to identify trends and patterns.",
                "Prepare reports and visualizations for stakeholders."
            ]
        },
        {
            title: "Sales Person",
            description: "Drive business growth by selling financial services and acquiring clients.",
            listItems: [
                "Approach and follow up with potential clients.",
                "Promote financial products to meet customer needs.",
                "Achieve sales targets and report performance metrics."
            ]
        },
        {
            title: "Relationship Manager (RM)",
            description: "Manage client relationships and provide ongoing service and support.",
            listItems: [
                "Build and maintain strong client relationships.",
                "Assist clients with queries and financial product selection.",
                "Act as a liaison between the client and service departments."
            ]
        }
    ];

    return (
        <Layout>
            <div className="tp-page-area sec-mar">
                <div className="container-fluid custom-container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="tp-page-content">
                                <div className="tp-page-post">
                                    <div data-elementor-type="wp-page" data-elementor-id="49" className="elementor elementor-49">
                                        <div className="elementor-element elementor-element-0b613d3 e-con-full e-flex e-con e-parent" data-id="0b613d3" data-element_type="container">
                                            <div className="elementor-element elementor-element-67f21b7 elementor-widget elementor-widget-tp-services" data-id="67f21b7" data-element_type="widget" data-widget_type="tp-services.default">
                                                <div className="elementor-widget-container">



                                                    <section className="careers_section section">
                                                        <div className="container">
                                                            <div className="row justify-content-center">
                                                                <div className="col-12 col-lg-6 col-xxl-5">
                                                                    <div className="section__header">
                                                                        <span
                                                                            className="sub-title section__header-sub-title headingFour wow fadeInDown txt_clr"
                                                                            data-wow-duration="0.8s">
                                                                            <img decoding="async"
                                                                                src="theme_assets/assets/themes/assets/images/title_vector.png"
                                                                                alt="Image" />Careers</span>
                                                                        <h2 className="title section__header-title wow fadeInUp"
                                                                            data-wow-duration="0.8s">Take the Next Step in Your Career with Us</h2>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </section>


                                                    <section className="feature feature--tertiary section careers_sectionCards">
                                                        <div className="container">
                                                            <div className="col-12 col-sm-12 col-xl-12">
                                                                <div className="row g-3 g-sm-2 g-md-3 g-xxl-4">

                                                                    {jobCards.map((card, index) => (

                                                                        <div className="col-12 col-sm-6 col-xl-4" key={index}>
                                                                            <div className="cus_card card card--custom gap-0 cus_align wow fadeInUp crd_hvr cardHoverBtnClr cstm_plan_card" data-wow-duration="0.8s">
                                                                                <div className='planCardUpper'>
                                                                                    <div className="card__content cus_cont crd_txt_clr">
                                                                                        <h4 className="card__title">
                                                                                            <NavLink to={"/careers"} className="cus_title_link">
                                                                                                {card.title}
                                                                                            </NavLink>
                                                                                        </h4>
                                                                                        <p className="fs-small">{card.description}</p>
                                                                                        <div>
                                                                                            <ul className='plan_details'>
                                                                                                {card.listItems.map((item, idx) => (
                                                                                                    <li>
                                                                                                        <div className='divCheck_price'><CiCircleAlert className='check_price' /></div>
                                                                                                        <div className='plandetatils_text' key={idx}><span>{item}</span></div>
                                                                                                    </li>
                                                                                                ))}
                                                                                            </ul>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                <div>
                                                                                    <div className="btn-cta ">
                                                                                        <NavLink to={"/careers"}
                                                                                            className="btn_theme mt_40 btn_clr plan_applyBtn">Apply</NavLink>
                                                                                    </div>
                                                                                </div>


                                                                            </div>
                                                                        </div>

                                                                    ))}

                                                                </div>
                                                            </div>
                                                        </div>

                                                    </section>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}
